import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PrivateRoute } from './components/PrivateRoute';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import MessagingPage from './pages/portal/MessagingPage';
import CalendarPage from './pages/portal/CalendarPage';
import PersonalProfilePage from './pages/portal/PersonalProfilePage';
import AnnouncementsPage from './pages/portal/AnnouncementsPage';
import HRRequests from './pages/portal/HRRequests';
import MyInfo from './pages/portal/MyInfo';
import MesaiTakipPage from './pages/portal/MesaiTakipPage';
import AdminPanel from './pages/admin/AdminPanel';
import HRPanel from './pages/hr/HRPanel';
import WorkPanel from './pages/work/WorkPanel';
import WorkDashboard from './pages/work/WorkDashboard';
import WorkTasks from './pages/work/WorkTasks';
import WorkRequests from './pages/work/WorkRequests';
import WorkCommunication from './pages/work/WorkCommunication';
import WorkReports from './pages/work/WorkReports';
import WorkAssignments from './pages/work/WorkAssignments';
import WorkCalendar from './pages/work/WorkCalendar';
import WorkProjects from './pages/work/WorkProjects';
import ManagerDailyAttendance from './pages/work/ManagerDailyAttendance';
import WorkJobs from './pages/work/WorkJobs';
import WorkSubcontractors from './pages/work/WorkSubcontractors';
import WorkServices from './pages/work/WorkServices';
import WorkFiles from './pages/work/WorkFiles';
import WorkWall from './pages/work/WorkWall';
import ShubeBilgileri from './pages/work/ShubeBilgileri';
import BranchPanel from './pages/branch/BranchPanel';
import BranchDashboard from './pages/branch/BranchDashboard';
import BranchEmployees from './pages/branch/BranchEmployees';
import BranchAttendance from './pages/branch/BranchAttendance';
import BranchTasks from './pages/branch/BranchTasks';
import BranchTasks2 from './pages/branch/BranchTasks2';
import BranchReports from './pages/branch/BranchReports';
import BranchAssignments from './pages/branch/BranchAssignments';
import BranchPerformance from './pages/branch/BranchPerformance';
import BranchStatistics from './pages/branch/BranchStatistics';
import BranchFiles from './pages/branch/BranchFiles';
import BranchWall from './pages/branch/BranchWall';
import BranchCommunication from './pages/branch/BranchCommunication';
import BranchIletisim from './pages/branch/BranchIletisim';
import BranchSubcontractors from './pages/branch/BranchSubcontractors';
import BranchServices from './pages/branch/BranchServices';
import BranchJobs from './pages/branch/BranchJobs';
import BranchCalendar from './pages/branch/BranchCalendar';
import BranchPersonnelRequests from './pages/branch/BranchPersonnelRequests';
import HRJobs from './pages/hr/HRJobs';
import BoardPanel from './pages/board/BoardPanel';
import BoardDashboard from './pages/board/BoardDashboard';
import BoardDepartment from './pages/board/BoardDepartment';
import BoardTalepler from './pages/board/BoardTalepler';
import BoardIsPlan from './pages/board/BoardIsPlan';
import BoardGorevler from './pages/board/BoardGorevler';
import BoardRaporlar from './pages/board/BoardRaporlar';
import BoardMesaiDurumu from './pages/board/BoardMesaiDurumu';
import BoardBirimIK from './pages/board/BoardBirimIK';
import BoardBirimMuhasebe from './pages/board/BoardBirimMuhasebe';
import BoardBirimIletisim from './pages/board/BoardBirimIletisim';
import BoardBirimFaizHesaplama from './pages/board/BoardBirimFaizHesaplama';
import BoardBirimSatinAlma from './pages/board/BoardBirimSatinAlma';
import BoardServices from './pages/board/BoardServices';
import BoardDepo from './pages/board/BoardDepo';
import BoardSubeYonetim from './pages/board/BoardSubeYonetim';
import BoardBranchTaseronlar from './pages/board/BoardBranchTaseronlar';
import DepotPanel from './pages/depot/DepotPanel';
import DepotEntry from './pages/depot/DepotEntry';
import DepotExit from './pages/depot/DepotExit';
import DepotStock from './pages/depot/DepotStock';
import DepotIncoming from './pages/depot/DepotIncoming';
import DepotDefective from './pages/depot/DepotDefective';
import DepotCommunication from './pages/depot/DepotCommunication';
import DepotJobs from './pages/depot/DepotJobs';
import PurchasingPanel from './pages/purchasing/PurchasingPanel';
import PurchasingIncomingRequests from './pages/purchasing/PurchasingIncomingRequests';
import PurchasingPurchased from './pages/purchasing/PurchasingPurchased';
import PurchasingWarehouses from './pages/purchasing/PurchasingWarehouses';
import PurchasingWarnings from './pages/purchasing/PurchasingWarnings';
import PurchasingRequests from './pages/purchasing/PurchasingRequests';
import PurchasingGlobalData from './pages/purchasing/PurchasingGlobalData';
import PurchasingCommunication from './pages/purchasing/PurchasingCommunication';
import PurchasingJobs from './pages/purchasing/PurchasingJobs';
import PurchasingStock from './pages/purchasing/PurchasingStock';
import PurchasingDemirbaslar from './pages/purchasing/PurchasingDemirbaslar';
import PurchasingOffers from './pages/purchasing/PurchasingOffers';
import PurchasingServices from './pages/purchasing/PurchasingServices';
import PurchasingSubcontractors from './pages/purchasing/PurchasingSubcontractors';
import AccountingPanel from './pages/accounting/AccountingPanel';
import AccountingIncome from './pages/accounting/AccountingIncome';
import AccountingExpenses from './pages/accounting/AccountingExpenses';
import AccountingFaturalar from './pages/accounting/AccountingFaturalar';
import AccountingChecks from './pages/accounting/AccountingChecks';
import AccountingCariHesaplar from './pages/accounting/AccountingCariHesaplar';
import AccountingHesapKartlari from './pages/accounting/AccountingHesapKartlari';
import AccountingHesapEkle from './pages/accounting/AccountingHesapEkle';
import AccountingTakipler from './pages/accounting/AccountingTakipler';
import AccountingCalendar from './pages/accounting/AccountingCalendar';
import AccountingCommunication from './pages/accounting/AccountingCommunication';
import AccountingRequests from './pages/accounting/AccountingRequests';
import AccountingJobs from './pages/accounting/AccountingJobs';
import AccountingWarnings from './pages/accounting/AccountingWarnings';
import './App.css';

const grayThemes = {
  'beyaz': '210 20% 98%',
  'acik': '210 15% 95%',
  'orta': '210 12% 92%',
  'koyu': '210 10% 89%',
};

function App() {
  // Sayfa yüklendiğinde kayıtlı temayı uygula
  React.useEffect(() => {
    const saved = localStorage.getItem('fortis_bg_theme') || 'acik';
    const bg = grayThemes[saved] || grayThemes['acik'];
    document.documentElement.style.setProperty('--background', bg);
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="messages" replace />} />
              <Route path="messages" element={<MessagingPage />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="profile" element={<PersonalProfilePage />} />
              <Route path="announcements" element={<AnnouncementsPage />} />
              <Route path="hr-requests" element={<HRRequests />} />
              <Route path="my-info" element={<MyInfo />} />
              <Route path="mesai-takip" element={<MesaiTakipPage />} />
            </Route>
            <Route 
              path="/admin/*" 
              element={
                <PrivateRoute requiredRole="admin">
                  <AdminPanel />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/hr/*" 
              element={
                <PrivateRoute requiredRole="hr_manager">
                  <HRPanel />
                </PrivateRoute>
              } 
            />
            {/* Work Panel Routes */}
            <Route 
              path="/work" 
              element={
                <PrivateRoute>
                  <WorkPanel />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<WorkDashboard />} />
              <Route path="jobs" element={<WorkJobs />} />
              <Route path="tasks" element={<WorkTasks />} />
              <Route path="requests" element={<WorkRequests />} />
              <Route path="communication" element={<WorkCommunication />} />
              <Route path="reports" element={<WorkReports />} />
              <Route path="assignments" element={<WorkAssignments />} />
              <Route path="calendar" element={<WorkCalendar />} />
              <Route path="projects" element={<WorkProjects />} />
              <Route path="manager-attendance" element={<ManagerDailyAttendance />} />
              <Route path="sube-bilgileri" element={<ShubeBilgileri />} />
              <Route path="subcontractors" element={<WorkSubcontractors />} />
              <Route path="services" element={<WorkServices />} />
              <Route path="files" element={<WorkFiles />} />
              <Route path="wall" element={<WorkWall />} />
              <Route path="wall/:postId" element={<WorkWall />} />
            </Route>
            {/* Branch Management Panel Routes */}
            <Route 
              path="/branch" 
              element={
                <PrivateRoute>
                  <BranchPanel />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<BranchDashboard />} />
              <Route path="employees" element={<BranchEmployees />} />
              <Route path="attendance" element={<BranchAttendance />} />
              <Route path="tasks" element={<BranchTasks2 />} />
              <Route path="assignments" element={<BranchAssignments />} />
              <Route path="reports" element={<BranchReports />} />
              <Route path="sube-bilgileri" element={<ShubeBilgileri />} />
              <Route path="communication" element={<BranchCommunication />} />
              <Route path="iletisim" element={<BranchIletisim />} />
              <Route path="subcontractors" element={<BranchSubcontractors />} />
              <Route path="services" element={<BranchServices />} />
              <Route path="jobs" element={<BranchJobs />} />
              <Route path="calendar" element={<BranchCalendar />} />
              <Route path="files" element={<BranchFiles />} />
              <Route path="wall" element={<BranchWall />} />
              <Route path="personnel-requests" element={<BranchPersonnelRequests />} />
              <Route path="wall/:postId" element={<BranchWall />} />
            </Route>
            {/* Board (Yönetim Kurulu) Panel Routes */}
            <Route 
              path="/board" 
              element={
                <PrivateRoute>
                  <BoardPanel />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<BoardDashboard />} />
              <Route path="branch/:branchId/talepler" element={<BoardTalepler />} />
              <Route path="branch/:branchId/is-plani" element={<BoardIsPlan />} />
              <Route path="branch/:branchId/gorevler" element={<BoardGorevler />} />
              <Route path="branch/:branchId/raporlar" element={<BoardRaporlar />} />
              <Route path="branch/:branchId/mesai-durumu" element={<BoardMesaiDurumu />} />
              <Route path="branch/:branchId/depo" element={<BoardDepo />} />
              <Route path="branch/:branchId/sube-yonetim" element={<BoardSubeYonetim />} />
              <Route path="branch/:branchId/taseronlar" element={<BoardBranchTaseronlar />} />
              <Route path="branch/:branchId/:department" element={<BoardDepartment />} />
              <Route path="birimler/insan-kaynaklari/*" element={<BoardBirimIK />} />
              <Route path="birimler/muhasebe" element={<BoardBirimMuhasebe />} />
              <Route path="birimler/iletisim" element={<BoardBirimIletisim />} />
              <Route path="birimler/faiz-hesaplama" element={<BoardBirimFaizHesaplama />} />
              <Route path="birimler/satin-alma/*" element={<BoardBirimSatinAlma />} />
              <Route path="birimler/alinan-hizmetler" element={<BoardServices />} />
            </Route>
            {/* Depot (Depo) Panel Routes */}
            <Route 
              path="/depot" 
              element={
                <PrivateRoute>
                  <DepotPanel />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="entry" replace />} />
              <Route path="entry" element={<DepotEntry />} />
              <Route path="exit" element={<DepotExit />} />
              <Route path="stock" element={<DepotStock />} />
              <Route path="incoming" element={<DepotIncoming />} />
              <Route path="defective" element={<DepotDefective />} />
              <Route path="jobs" element={<DepotJobs />} />
              <Route path="calendar" element={<WorkCalendar />} />
              <Route path="communication" element={<DepotCommunication />} />
            </Route>
            {/* Purchasing (Satın Alma) Panel Routes */}
            <Route 
              path="/purchasing" 
              element={
                <PrivateRoute>
                  <PurchasingPanel />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="stock" replace />} />
              <Route path="stock" element={<PurchasingStock />} />
              <Route path="demirbaslar" element={<PurchasingDemirbaslar />} />
              <Route path="global-data" element={<PurchasingGlobalData />} />
              <Route path="communication" element={<PurchasingCommunication />} />
              <Route path="requests" element={<Navigate to="/purchasing/jobs" replace />} />
              <Route path="jobs" element={<PurchasingJobs />} />
              <Route path="offers" element={<PurchasingOffers />} />
              <Route path="services" element={<PurchasingServices />} />
              <Route path="subcontractors" element={<PurchasingSubcontractors />} />
              <Route path="purchased" element={<PurchasingPurchased />} />
              <Route path="warehouses" element={<PurchasingWarehouses />} />
              <Route path="warnings" element={<PurchasingWarnings />} />
              <Route path="calendar" element={<WorkCalendar />} />
            </Route>
            {/* Accounting (Muhasebe) Panel Routes */}
            <Route 
              path="/accounting" 
              element={
                <PrivateRoute>
                  <AccountingPanel />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="income" replace />} />
              <Route path="income" element={<AccountingIncome />} />
              <Route path="expenses" element={<AccountingExpenses />} />
              <Route path="faturalar" element={<AccountingFaturalar />} />
              <Route path="takipler" element={<AccountingTakipler />} />
              <Route path="checks" element={<AccountingChecks />} />
              <Route path="cari-hesaplar" element={<AccountingCariHesaplar />} />
              <Route path="hesap-kartlari" element={<AccountingHesapKartlari />} />
              <Route path="hesap-ekle" element={<AccountingHesapEkle />} />
              <Route path="calendar" element={<AccountingCalendar />} />
              <Route path="communication" element={<AccountingCommunication />} />
              <Route path="requests" element={<AccountingRequests />} />
              <Route path="jobs" element={<AccountingJobs />} />
              <Route path="warnings" element={<AccountingWarnings />} />
            </Route>
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
          <Toaster position="bottom-left" />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
